import { observer } from 'mobx-react-lite';
import { ComponentProps, ReactElement } from 'react';

export const EditIcon = observer(
  (props: ComponentProps<'svg'>): ReactElement => (
    <svg
      {...props}
      width='24'
      height='24'
      viewBox='0 0 2400 2400'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1738.992 305.707 C 1715.557 314.070,1700.233 327.345,1604.000 422.645 L 1514.000 511.772 1700.978 698.858 L 1887.955 885.945 1948.373 825.972 C 2026.563 748.359,2082.315 686.984,2092.164 667.679 C 2102.023 648.353,2102.044 622.890,2092.219 601.249 C 2082.894 580.710,1985.371 477.554,1884.800 381.849 C 1820.834 320.978,1809.010 311.422,1791.074 306.095 C 1766.393 298.766,1758.604 298.708,1738.992 305.707 M852.989 1173.011 L 300.000 1726.011 300.000 1898.194 L 300.000 2070.376 315.169 2085.188 L 330.337 2100.000 494.169 2099.985 C 649.505 2099.971,658.663 2099.566,670.783 2092.176 C 687.449 2082.014,1054.812 1719.949,1459.003 1315.323 L 1780.007 993.975 1592.993 806.993 L 1405.979 620.010 852.989 1173.011 '
        fill='currentColor'
        stroke='none'
        fillRule='evenodd'
      />
    </svg>
  )
);
